import { IncrementField } from 'apps/builder/components/settings/modal/fields/IncrementField'
import { SliderField } from 'apps/builder/components/settings/modal/fields/SliderField'
import { NumberField } from 'apps/builder/components/settings/modal/fields/NumberField'

export const NumberSettings = ({ style, ...props }) => {
  switch (style) {
    case 0:
      return <NumberField style={style} {...props} />
    case 1:
      return <IncrementField style={style} {...props} />
    case 2:
      return <SliderField style={style} {...props} />
    default:
      return <NumberField style={style} {...props} />
  }
}
